import React, { useState, useEffect, useContext } from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import styled from 'styled-components';
import { Box, Header as GrommetHeader, ResponsiveContext } from 'grommet';
// eslint-disable-next-line import/no-cycle
import { GatsbyImage } from 'gatsby-plugin-image';
// eslint-disable-next-line import/no-cycle
import Navigation from './Navigation';
import { Button } from '../Button';
import Hamburger from './Hamburger';

const SiteLogo = styled.div`
  a {
    display: block;
  }
`;

export const DemoButton = () => (
  <Button id="demo" label="Contact us" href="/contact" />
);

const StyledHeader = styled(GrommetHeader)`
  height: var(--headerHeight);
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  z-index: 9001;
  width: 100%;
  position: fixed;
  > div {
    ${({ theme }) => theme.custom.helpers.LayoutContainer``};
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

const Header = () => {
  const { headerLogoDesktop, headerLogoMobile } = useStaticQuery(graphql`
    {
      headerLogoDesktop: contentfulAsset(title: { eq: "Header Logo" }) {
        gatsbyImageData(
          height: 50
          formats: AUTO
          outputPixelDensities: 2
          quality: 100
          layout: FIXED
          placeholder: NONE
        )
        description
      }
      headerLogoMobile: contentfulAsset(title: { eq: "Header Logo" }) {
        gatsbyImageData(
          height: 32
          formats: AUTO
          placeholder: NONE
          outputPixelDensities: 2
          quality: 100
          layout: FIXED
        )
        description
      }
    }
  `);

  const size = useContext(ResponsiveContext);
  const useMobileNav = size === 'medium' || size === 'small';
  const [isOpen, setIsOpen] = useState(false);

  return (
    <StyledHeader>
      <Box gap="medium" direction="row" wrap={false}>
        <SiteLogo>
          <Link to="/" title="Home">
            {useMobileNav ? (
              <GatsbyImage
                loading="eager"
                image={headerLogoMobile.gatsbyImageData}
                alt={headerLogoMobile.description}
              />
            ) : (
              <GatsbyImage
                loading="eager"
                image={headerLogoDesktop.gatsbyImageData}
                alt={headerLogoDesktop.description}
              />
            )}
          </Link>
        </SiteLogo>
        <Navigation isOpen={isOpen} />
        {useMobileNav && (
          <Hamburger isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} />
        )}
      </Box>
    </StyledHeader>
  );
};

export default Header;
